import { render, staticRenderFns } from "./TransmissaoSubmenu.vue?vue&type=template&id=0f12cb52"
import script from "./TransmissaoSubmenu.vue?vue&type=script&lang=js"
export * from "./TransmissaoSubmenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports